'use strict';

angular.module('atex.art').factory('DeskSiteService', [
  '$rootScope', '$q', 'AuthenticationService', 'ContentService',
  function($rootScope, $q, AuthenticationService, ContentService) {

    var getWithContentId = function (id) {
      if (!id.startsWith('contentid/')) {
        return 'contentid/' + id;
      }
      return id;
    };

    var withExternalId = function(source, responseInfo) {
      var siteExternalId = atex.onecms.ObjectUtils.getByPath(responseInfo, 'data/aspects/contentData/data/externalId');

      if (siteExternalId) {
        return _.extend({}, source, {externalId: siteExternalId});
      } else {
        return source;
      }
    };

    var getSite = function (site, config) {
      config = config || {};
      var excludedSites = config.excludedSites || [];
      var currentDepth = config.currentDepth || 1;
      var maxDepth = config.maxDepth || 100;
      var showSubPages = config.showSubPages || false;
      var variant = "atex.onecms.structure" + ((excludedSites) ? '&excludedSites=' + encodeURI(excludedSites.join(','))
        : "");
      return ContentService.getContent({id: site.id, variant: variant}).then(function (responseInfo) {
        var id = getWithContentId(responseInfo.id);
        var name = atex.onecms.ObjectUtils.getByPath(responseInfo, "data/aspects/contentData/data/name") || responseInfo.id;
        var data = withExternalId({id: id, name: name}, responseInfo);

        if (showSubPages && currentDepth < 100) {
          data.children = atex.onecms.ObjectUtils.getByPath(responseInfo, 'data/aspects/contentData/data/children') || [];
          data.children.forEach(function (child) {
            var currentChildren = child.children;
            var depth = currentDepth;
            while (currentChildren && depth < maxDepth && currentChildren.length > 0) {
              depth++;
              if (depth === maxDepth) {
                child.children = [];
              } else {
                currentChildren = currentChildren.children;
              }
            }
          });
        } else {
          data.children = [];
        }

        return data;
      });
    };

    var getSites = function (sites, config) {
      var sitePromises = sites.map(function(site) {
        return getSite(site, config);
      });
      return $q.allSettled(sitePromises).then(function (results) {
        return atex.onecms.AngularUtils.splitSettled(results).fulfilled;
      });
    };

    var getWorkingSites = function () {
      return AuthenticationService.getCurrentUserData().then(function (userDataContent) {
        return atex.onecms.ObjectUtils.getByPath(userDataContent, 'workingSites') || [];
      });
    };

    return {
      getSite: getSite,
      getSites: getSites,
      getWorkingSites: getWorkingSites
    };
  }
]);
